import React, { useEffect, useState } from "react";
import Header from "../features/Header";
import api from "../api/axios";
import "./newspage.css";

const NewsPage = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const response = await api.get("/api/v1/news");
        setNews(response.data.news);
      } catch (error) {
        console.error("Помилка завантаження новин:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, []);

  return (
    <>
      <Header />
      <div className="news-container">
        <h1 className="news-title">Новини</h1>

        {loading ? (
          <p>Завантаження новин...</p>
        ) : (
          <>
            <div className="news-list">
              {news.map((item) => (
                <div key={item.ID} className="news-card">
                  {item.ImageURL ? (
                    <img 
                      src={item.ImageURL} 
                      alt={item.Title} 
                      className="news-image" 
                    />
                  ) : (
                    <div className="news-image-placeholder">
                      Зображення відсутнє
                    </div>
                  )}
                  <div className="news-content">
                    <span className="news-card-title">{item.Title}</span>
                    <span className="news-card-date">
                      {new Date(item.Date).toLocaleDateString()}
                    </span>
                    <p className="news-card-content">{item.Content}</p>
                    <p className="news-card-author">Автор: {item.Username}</p>
                    <a href={`/news/${item.ID}`} className="read-more-btn">
                      Читати більше →
                    </a>
                  </div>
                </div>
              ))}
            </div>


          </>
        )}
      </div>
    </>
  );
};

export default NewsPage;